export enum PaperSideType {
  SingleSided,
  DoubleSided,
}
